
<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-full md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card style="background: rgba(250, 250, 250, 0.88);">
        <div class="vx-row">
          <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto" />
          </div>
          <div
            class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            style="background: #ffffff00;"
          >
            <div class="p-8">
              <img src="@/assets/images/logo/startup_logo.png" alt="login" class="mx-auto" />
              <div class="vx-card__title mb-4 text-center">
                <h2>DSS CCMS</h2>
              </div>
              <div class="vx-card__title text-center">
                <h4 class="mb-4">Create Account</h4>
                <p style="color:black;font-size:medium">Fill the below form to create a new account.</p>
              </div>
              <div class="clearfix">
                <vs-input
                  v-validate="'required|alpha_dash|min:3'"
                  data-vv-validate-on="blur"
                  label-placeholder="Username"
                  name="Username"
                  placeholder="Username"
                  v-model="username"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{ errors.first('Username') }}</span>

                <vs-input
                  v-validate="'required|email'"
                  data-vv-validate-on="blur"
                  name="Email"
                  type="email"
                  label-placeholder="Email"
                  placeholder="Email"
                  v-model="email"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first('Email') }}</span>
                <vs-input
                  v-validate="{required:true,regex: '^(([6-9]{1}[0-9]{9}))$' }"
                  data-vv-validate-on="blur"
                  label-placeholder="Phone Number"
                  placeholder="Phone Number"
                  name="Phone Number"
                  v-model="phoneNumber"
                  class="mt-6 w-full"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Phone Number')"
                >{{ errors.first('Phone Number') }}</span>
                <vs-input
                  ref="password"
                  type="password"
                  data-vv-validate-on="blur"
                  v-validate="'required|min:8|max:10'"
                  name="Password"
                  label-placeholder="Password"
                  placeholder="Password"
                  v-model="password"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first('Password') }}</span>

                <vs-input
                  type="password"
                  v-validate="'min:8|max:10|confirmed:password'"
                  data-vv-validate-on="blur"
                  data-vv-as="password"
                  name="confirm_password"
                  label-placeholder="Confirm Password"
                  placeholder="Confirm Password"
                  v-model="confirm_password"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                <!-- <vs-checkbox
                  v-model="isTermsConditionAccepted"
                  class="mt-6"
                >I accept the terms & conditions.</vs-checkbox>-->
                <vs-button color="success" type="filled" to="/pages/login" class="mt-6">Login</vs-button>
                <vs-button
                  color="dark"
                  type="filled"
                  class="float-right mt-6"
                  @click="registerUser"
                  :disabled="!validateForm"
                >Register</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

import db from "@/firebase/firebaseConfig.js";

export default {
  data() {
    return {
      username: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirm_password: "",
      isTermsConditionAccepted: true,
      endpoint: this.$store.state.endpoint2
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.username != "" &&
        this.email != "" &&
        this.phoneNumber != "" &&
        this.password != "" &&
        this.confirm_password != "" &&
        this.isTermsConditionAccepted === true
      );
    }
  },
  created() {},
  methods: {
    registerUser() {
      if (!this.validateForm) return false;
      // create user using firebase
      var self = this;
      const loginPayload = {
        userDetails: {
          email: this.email.toLowerCase(),
          password: this.password
        },
        notify: this.$vs.notify
      };

      var payload = {
        userName: this.username,
        email: this.email.toLowerCase(),
        phoneNumber: this.phoneNumber,
        userType: "user"
      };

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            this.$vs.notify({
              title: "Account Created",
              text: "You are successfully registered!",
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
            // db.collection("users")
            //   .add({
            //     userName: this.username,
            //     email: this.email.toLowerCase(),
            //     phoneNumber: this.phoneNumber
            //   })
            //   .then(docRef => {
            //     self.$store.dispatch("login", loginPayload);
            //   })
            //   .catch(error => {
            //     this.$vs.notify({
            //       title: "Error",
            //       text: error.message,
            //       iconPack: "feather",
            //       icon: "icon-alert-circle",
            //       color: "danger"
            //     });
            //   });

            this.$http.post(this.endpoint + "/adduser", payload).then(
              response => {
                var data = response.data;
                self.$store.dispatch("login", loginPayload);
                console.log(response.data);
              },
              error => {
                this.$vs.notify({
                  title: "Error",
                  text: error.response.data,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger"
                });
              }
            );
          },
          error => {
            this.$vs.notify({
              title: "Error",
              text: error.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        );
    },
    notifyAlreadyLogedIn() {
      this.$vs.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
    }
  }
};
</script>
